<tt-page *ngIf="!!setting">
    <div class="col-xs-12 sp-0" *ngIf="'mobile' | mediaQuery">
        <tt-card>
            <tt-select ttLabel="language_name" [(ttModel)]="setting.language_id" (ttModelChange)="onChanged($event, 'language_id')" [ttData]="selectListLanguages" ttDataId="item_id" ttDataName="item_name"></tt-select>
            <tt-input ttLabel="filterval" ttFocus="false" [(ttModel)]="setting.filterval" ttShowClearButton></tt-input>

            <tt-tabs [(ttSelectedId)]="selectedBgHelpDocTTChanged" (ttSelectedIdChange)="onTabChanged()">
                <tt-tab ttId="TODO" ttLabel="bg_helpdocttchanged_todo"></tt-tab>
                <tt-tab ttId="CHANGED" ttLabel="bg_helpdocttchanged_changed"></tt-tab>
            </tt-tabs>
        </tt-card>

        <tt-list [ttData]="itemsListHelpDocChanged" [ttFilter]="setting.filterval"></tt-list>
    </div>

    <div *ngIf="['tablet', 'laptop', 'desktop'] | mediaQuery">
        <div class="col-xs-12 sp-0">
            <tt-card class="col-xs-12 col-md-3 p-5">
                <tt-select ttLabel="language_name" [(ttModel)]="setting.language_id" (ttModelChange)="onChanged($event, 'language_id')" [ttData]="selectListLanguages" ttDataId="item_id" ttDataName="item_name"></tt-select>
            </tt-card>

            <tt-card class="col-xs-12 col-md-3 p-5">
                <tt-input ttLabel="filterval" ttFocus="false" [(ttModel)]="setting.filterval" ttShowClearButton></tt-input>
            </tt-card>
        </div>

        <div class="col-xs-12 col-md-6 p-5">
            <tt-card>
                <tt-tabs [(ttSelectedId)]="selectedBgHelpDocTTChanged" (ttSelectedIdChange)="onTabChanged()">
                    <tt-tab ttId="TODO" ttLabel="bg_helpdocttchanged_todo"></tt-tab>
                    <tt-tab ttId="CHANGED" ttLabel="bg_helpdocttchanged_changed"></tt-tab>
                </tt-tabs>
            </tt-card>

            <tt-list [ttData]="itemsListHelpDocChanged" [ttFilter]="setting.filterval"></tt-list>
        </div>
    </div>
</tt-page>
